import React from "react";
import Select from "react-select";

// Estilos para controlar z-index y evitar superposiciones
const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 1050,
    fontSize: '13px',
    fontFamily: 'inherit'
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 1050
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: '38px',
    height: '38px',
    fontSize: '13px',
    fontWeight: '400',
    fontFamily: 'inherit',
    boxShadow: 'none',
    borderRadius: '10px', /* Standardized to 10px */
    borderWidth: '2px',
    borderColor: state.isFocused ? '#17a2b8' : '#ced4da', /* Industrial Cyan */
    '&:hover': {
      borderColor: '#17a2b8'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '36px', // Ajustado para centrar con la altura de 38px
    padding: '0 8px',
    marginTop: '-1px'
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px',
    padding: '0px',
    fontSize: '13px',
    fontFamily: 'inherit'
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '36px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '4px',
    color: '#ced4da',
    '&:hover': {
      color: '#adb5bd'
    }
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '4px',
    color: '#ced4da',
    '&:hover': {
      color: '#dc3545'
    }
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '13px',
    fontWeight: '400',
    fontFamily: 'inherit',
    margin: '0px'
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '13px',
    fontFamily: 'inherit',
    backgroundColor: state.isSelected ? '#17a2b8' : state.isFocused ? '#f8f9fa' : 'white',
    color: state.isSelected ? 'white' : 'inherit',
    padding: '6px 10px'
  })
};

function CustomSelect({
  options,
  value,
  onChange,
  placeholder = "Seleccione...",
  label,
  error,
  isDisabled = false,
  isLoading = false,
  isClearable = true,
  isSearchable = true,
  required = false,
  className = ""
}) {

  // Encontrar el valor seleccionado en las opciones
  const getSelectedValue = () => {
    if (!value) return null;

    // Si value es un objeto con value y label
    if (typeof value === 'object' && value.value !== undefined) {
      return value;
    }

    // Si value es un string o number, buscar en options
    return options.find(option => option.value === value) || null;
  };

  const selectedValue = getSelectedValue();

  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label>
          {label}
          {required && <span className="text-danger"> *</span>}
        </label>
      )}
      <Select
        styles={customStyles}
        options={options}
        value={selectedValue}
        onChange={(selectedOption) => onChange(selectedOption ? selectedOption.value : null)}
        placeholder={placeholder}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isDisabled={isDisabled}
        isLoading={isLoading}
        menuPortalTarget={document.body}
        noOptionsMessage={() => "No hay opciones disponibles"}
        loadingMessage={() => "Cargando..."}
      />
      {error && (
        <div className="invalid-feedback d-block">
          {error}
        </div>
      )}
    </div>
  );
}

export default CustomSelect;
